module.exports = __webpack_public_path__ + "img/blue-en.976d92ea.jpg";